import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file fluxer/user/preferences/v1/pickers.proto.
 */
export const file_fluxer_user_preferences_v1_pickers: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message fluxer.user.preferences.v1.UsageStat
 */
export type UsageStat = Message<"fluxer.user.preferences.v1.UsageStat"> & {
  /**
   * @generated from field: uint32 count = 1;
   */
  count: number;

  /**
   * @generated from field: int64 last_used_ms = 2;
   */
  lastUsedMs: bigint;
};

/**
 * Describes the message fluxer.user.preferences.v1.UsageStat.
 * Use `create(UsageStatSchema)` to create a new message.
 */
export const UsageStatSchema: GenMessage<UsageStat> = /*@__PURE__*/
  messageDesc(file_fluxer_user_preferences_v1_pickers, 0);

/**
 * @generated from message fluxer.user.preferences.v1.EmojiPickerState
 */
export type EmojiPickerState = Message<"fluxer.user.preferences.v1.EmojiPickerState"> & {
  /**
   * @generated from field: map<string, fluxer.user.preferences.v1.UsageStat> usage = 1;
   */
  usage: { [key: string]: UsageStat };

  /**
   * @generated from field: repeated string favorite_emoji_ids = 2;
   */
  favoriteEmojiIds: string[];

  /**
   * @generated from field: repeated string collapsed_category_ids = 3;
   */
  collapsedCategoryIds: string[];
};

/**
 * Describes the message fluxer.user.preferences.v1.EmojiPickerState.
 * Use `create(EmojiPickerStateSchema)` to create a new message.
 */
export const EmojiPickerStateSchema: GenMessage<EmojiPickerState> = /*@__PURE__*/
  messageDesc(file_fluxer_user_preferences_v1_pickers, 1);

/**
 * @generated from message fluxer.user.preferences.v1.StickerPickerState
 */
export type StickerPickerState = Message<"fluxer.user.preferences.v1.StickerPickerState"> & {
  /**
   * @generated from field: map<string, fluxer.user.preferences.v1.UsageStat> usage = 1;
   */
  usage: { [key: string]: UsageStat };

  /**
   * @generated from field: repeated string favorite_sticker_ids = 2;
   */
  favoriteStickerIds: string[];

  /**
   * @generated from field: repeated string collapsed_category_ids = 3;
   */
  collapsedCategoryIds: string[];
};

/**
 * Describes the message fluxer.user.preferences.v1.StickerPickerState.
 * Use `create(StickerPickerStateSchema)` to create a new message.
 */
export const StickerPickerStateSchema: GenMessage<StickerPickerState> = /*@__PURE__*/
  messageDesc(file_fluxer_user_preferences_v1_pickers, 2);

/**
 * @generated from message fluxer.user.preferences.v1.MemesPickerState
 */
export type MemesPickerState = Message<"fluxer.user.preferences.v1.MemesPickerState"> & {
  /**
   * @generated from field: map<string, fluxer.user.preferences.v1.UsageStat> usage = 1;
   */
  usage: { [key: string]: UsageStat };

  /**
   * @generated from field: repeated string favorite_meme_ids = 2;
   */
  favoriteMemeIds: string[];

  /**
   * @generated from field: repeated string collapsed_category_ids = 3;
   */
  collapsedCategoryIds: string[];
};

/**
 * Describes the message fluxer.user.preferences.v1.MemesPickerState.
 * Use `create(MemesPickerStateSchema)` to create a new message.
 */
export const MemesPickerStateSchema: GenMessage<MemesPickerState> = /*@__PURE__*/
  messageDesc(file_fluxer_user_preferences_v1_pickers, 3);

/**
 * parley: the soundboard panel keeps the same three things every other
 * picker keeps (strand AJ, docs/strands/soundboard.md). It rides inside
 * synced_preferences, which the API stores as an opaque base64 string, so
 * favourites travel between devices without a new settings field.
 *
 * @generated from message fluxer.user.preferences.v1.SoundboardState
 */
export type SoundboardState = Message<"fluxer.user.preferences.v1.SoundboardState"> & {
  /**
   * @generated from field: map<string, fluxer.user.preferences.v1.UsageStat> usage = 1;
   */
  usage: { [key: string]: UsageStat };

  /**
   * @generated from field: repeated string favorite_sound_ids = 2;
   */
  favoriteSoundIds: string[];

  /**
   * @generated from field: repeated string collapsed_section_ids = 3;
   */
  collapsedSectionIds: string[];
};

/**
 * Describes the message fluxer.user.preferences.v1.SoundboardState.
 * Use `create(SoundboardStateSchema)` to create a new message.
 */
export const SoundboardStateSchema: GenMessage<SoundboardState> = /*@__PURE__*/
  messageDesc(file_fluxer_user_preferences_v1_pickers, 4);

/**
 * @generated from message fluxer.user.preferences.v1.EmojiState
 */
export type EmojiState = Message<"fluxer.user.preferences.v1.EmojiState"> & {
  /**
   * @generated from field: string skin_tone = 1;
   */
  skinTone: string;
};

/**
 * Describes the message fluxer.user.preferences.v1.EmojiState.
 * Use `create(EmojiStateSchema)` to create a new message.
 */
export const EmojiStateSchema: GenMessage<EmojiState> = /*@__PURE__*/
  messageDesc(file_fluxer_user_preferences_v1_pickers, 5);

/**
 * @generated from message fluxer.user.preferences.v1.EmojiStickerLayoutSettings
 */
export type EmojiStickerLayoutSettings = Message<"fluxer.user.preferences.v1.EmojiStickerLayoutSettings"> & {
  /**
   * @generated from field: fluxer.user.preferences.v1.EmojiPickerLayout emoji_layout = 1;
   */
  emojiLayout: EmojiPickerLayout;

  /**
   * @generated from field: fluxer.user.preferences.v1.StickerPickerViewMode sticker_view_mode = 2;
   */
  stickerViewMode: StickerPickerViewMode;
};

/**
 * Describes the message fluxer.user.preferences.v1.EmojiStickerLayoutSettings.
 * Use `create(EmojiStickerLayoutSettingsSchema)` to create a new message.
 */
export const EmojiStickerLayoutSettingsSchema: GenMessage<EmojiStickerLayoutSettings> = /*@__PURE__*/
  messageDesc(file_fluxer_user_preferences_v1_pickers, 6);

/**
 * @generated from message fluxer.user.preferences.v1.FavoriteGifSettings
 */
export type FavoriteGifSettings = Message<"fluxer.user.preferences.v1.FavoriteGifSettings"> & {
  /**
   * @generated from field: repeated fluxer.user.preferences.v1.FavoriteGifEntry entries = 1;
   */
  entries: FavoriteGifEntry[];

  /**
   * @generated from field: bool save_as_saved_media = 2;
   */
  saveAsSavedMedia: boolean;

  /**
   * @generated from field: bool seen_first_time_prompt = 3;
   */
  seenFirstTimePrompt: boolean;
};

/**
 * Describes the message fluxer.user.preferences.v1.FavoriteGifSettings.
 * Use `create(FavoriteGifSettingsSchema)` to create a new message.
 */
export const FavoriteGifSettingsSchema: GenMessage<FavoriteGifSettings> = /*@__PURE__*/
  messageDesc(file_fluxer_user_preferences_v1_pickers, 7);

/**
 * @generated from message fluxer.user.preferences.v1.FavoriteGifMediaFormat
 */
export type FavoriteGifMediaFormat = Message<"fluxer.user.preferences.v1.FavoriteGifMediaFormat"> & {
  /**
   * @generated from field: string src = 1;
   */
  src: string;

  /**
   * @generated from field: string proxy_src = 2;
   */
  proxySrc: string;

  /**
   * @generated from field: uint32 width = 3;
   */
  width: number;

  /**
   * @generated from field: uint32 height = 4;
   */
  height: number;
};

/**
 * Describes the message fluxer.user.preferences.v1.FavoriteGifMediaFormat.
 * Use `create(FavoriteGifMediaFormatSchema)` to create a new message.
 */
export const FavoriteGifMediaFormatSchema: GenMessage<FavoriteGifMediaFormat> = /*@__PURE__*/
  messageDesc(file_fluxer_user_preferences_v1_pickers, 8);

/**
 * @generated from message fluxer.user.preferences.v1.FavoriteGifEntry
 */
export type FavoriteGifEntry = Message<"fluxer.user.preferences.v1.FavoriteGifEntry"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string proxy_url = 2;
   */
  proxyUrl: string;

  /**
   * @generated from field: uint32 width = 3;
   */
  width: number;

  /**
   * @generated from field: uint32 height = 4;
   */
  height: number;

  /**
   * @generated from field: map<string, fluxer.user.preferences.v1.FavoriteGifMediaFormat> media = 5;
   */
  media: { [key: string]: FavoriteGifMediaFormat };

  /**
   * @generated from field: string content_type = 6;
   */
  contentType: string;

  /**
   * @generated from field: string placeholder = 7;
   */
  placeholder: string;
};

/**
 * Describes the message fluxer.user.preferences.v1.FavoriteGifEntry.
 * Use `create(FavoriteGifEntrySchema)` to create a new message.
 */
export const FavoriteGifEntrySchema: GenMessage<FavoriteGifEntry> = /*@__PURE__*/
  messageDesc(file_fluxer_user_preferences_v1_pickers, 9);

/**
 * @generated from message fluxer.user.preferences.v1.SoundSettings
 */
export type SoundSettings = Message<"fluxer.user.preferences.v1.SoundSettings"> & {
  /**
   * @generated from field: bool all_sounds_disabled = 1;
   */
  allSoundsDisabled: boolean;

  /**
   * @generated from field: optional double master_volume = 2;
   */
  masterVolume?: number | undefined;

  /**
   * @generated from field: map<string, bool> disabled_sounds = 3;
   */
  disabledSounds: { [key: string]: boolean };

  /**
   * @generated from field: map<string, double> sound_overrides = 4;
   */
  soundOverrides: { [key: string]: number };
};

/**
 * Describes the message fluxer.user.preferences.v1.SoundSettings.
 * Use `create(SoundSettingsSchema)` to create a new message.
 */
export const SoundSettingsSchema: GenMessage<SoundSettings> = /*@__PURE__*/
  messageDesc(file_fluxer_user_preferences_v1_pickers, 10);

/**
 * @generated from enum fluxer.user.preferences.v1.EmojiPickerLayout
 */
export enum EmojiPickerLayout {
  /**
   * @generated from enum value: EMOJI_PICKER_LAYOUT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EMOJI_PICKER_LAYOUT_LIST = 1;
   */
  LIST = 1,

  /**
   * @generated from enum value: EMOJI_PICKER_LAYOUT_GRID = 2;
   */
  GRID = 2,
}

/**
 * Describes the enum fluxer.user.preferences.v1.EmojiPickerLayout.
 */
export const EmojiPickerLayoutSchema: GenEnum<EmojiPickerLayout> = /*@__PURE__*/
  enumDesc(file_fluxer_user_preferences_v1_pickers, 0);

/**
 * @generated from enum fluxer.user.preferences.v1.StickerPickerViewMode
 */
export enum StickerPickerViewMode {
  /**
   * @generated from enum value: STICKER_PICKER_VIEW_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STICKER_PICKER_VIEW_MODE_COZY = 1;
   */
  COZY = 1,

  /**
   * @generated from enum value: STICKER_PICKER_VIEW_MODE_COMPACT = 2;
   */
  COMPACT = 2,
}

/**
 * Describes the enum fluxer.user.preferences.v1.StickerPickerViewMode.
 */
export const StickerPickerViewModeSchema: GenEnum<StickerPickerViewMode> = /*@__PURE__*/
  enumDesc(file_fluxer_user_preferences_v1_pickers, 1);

/**
 * @generated from enum fluxer.user.preferences.v1.SoundType
 */
export enum SoundType {
  /**
   * @generated from enum value: SOUND_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SOUND_TYPE_DEAF = 1;
   */
  DEAF = 1,

  /**
   * @generated from enum value: SOUND_TYPE_UNDEAF = 2;
   */
  UNDEAF = 2,

  /**
   * @generated from enum value: SOUND_TYPE_MUTE = 3;
   */
  MUTE = 3,

  /**
   * @generated from enum value: SOUND_TYPE_UNMUTE = 4;
   */
  UNMUTE = 4,

  /**
   * @generated from enum value: SOUND_TYPE_MESSAGE = 5;
   */
  MESSAGE = 5,

  /**
   * @generated from enum value: SOUND_TYPE_INCOMING_RING = 6;
   */
  INCOMING_RING = 6,

  /**
   * @generated from enum value: SOUND_TYPE_USER_JOIN = 7;
   */
  USER_JOIN = 7,

  /**
   * @generated from enum value: SOUND_TYPE_USER_LEAVE = 8;
   */
  USER_LEAVE = 8,

  /**
   * @generated from enum value: SOUND_TYPE_USER_MOVE = 9;
   */
  USER_MOVE = 9,

  /**
   * @generated from enum value: SOUND_TYPE_VIEWER_JOIN = 10;
   */
  VIEWER_JOIN = 10,

  /**
   * @generated from enum value: SOUND_TYPE_VIEWER_LEAVE = 11;
   */
  VIEWER_LEAVE = 11,

  /**
   * @generated from enum value: SOUND_TYPE_VOICE_DISCONNECT = 12;
   */
  VOICE_DISCONNECT = 12,

  /**
   * @generated from enum value: SOUND_TYPE_CAMERA_ON = 13;
   */
  CAMERA_ON = 13,

  /**
   * @generated from enum value: SOUND_TYPE_CAMERA_OFF = 14;
   */
  CAMERA_OFF = 14,

  /**
   * @generated from enum value: SOUND_TYPE_SCREEN_SHARE_START = 15;
   */
  SCREEN_SHARE_START = 15,

  /**
   * @generated from enum value: SOUND_TYPE_SCREEN_SHARE_STOP = 16;
   */
  SCREEN_SHARE_STOP = 16,
}

/**
 * Describes the enum fluxer.user.preferences.v1.SoundType.
 */
export const SoundTypeSchema: GenEnum<SoundType> = /*@__PURE__*/
  enumDesc(file_fluxer_user_preferences_v1_pickers, 2);
